import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, Input, Tooltip } from 'antd';
import { Widget, MasterDetailForm, Row, Table, ColumnProps, OptionProps, FormSelect, FormMonthPicker, Button, FormSubmitButton, FormatText, FormInput, Form, FormResetButton, Col, notification } from '@digital/ui';
import {
    getAllADistribuirByProjetoId,
    ProjetoOrdemInvestimentoADistribuirTotalizador,
    updateTipoDistribuicaoConsolidadoPlurianual,
    updatePeriodoInicialConsolidadoPluriAnual,
    updatePeriodoFinalConsolidadoPluriAnual,
    CreatAdcionarMesAno,
    updateValorConsolidadoPluriAnualItemDistribuir,
    getConsolidadoPluriAnualItemDistribuir,
    exportarADistribuir
} from '../../api/aDistribuir'
import { getAllContratoOrdemInvestimentoPlurianualByProjetoId, Projeto, ProjetoOrdemInvestimentoPlurianual } from '@app/api/projeto';
import moment from 'moment';
import CurrencyInput from '@app/components/CurrencyInput';
import { currencyFormat, handleParser } from '@app/helpers/numbers';
import { compareText } from '@app/helpers/comparators';
import { PaginationConfig } from 'antd/lib/pagination';
import LinkRequisitadoProjeto from '@app/components/linkRequisitadoProjeto';
import UploadFileDefault from '@app/components/uploadFileDefault';
import PaginacaoTabela from '@app/components/paginacaoTabela';
import { newGuid } from '@app/helpers/generatorGuid';
import { getStatusAtualizacaoADistribuirByProjeto } from '@app/api/routines';

const { Panel } = Collapse;
interface PropFormAContratar {
    selectedItem: Projeto;
    listTipoDistribuicaoForcast: OptionProps[]
}

interface tipoColuna {
    colunaPrincipal: string,
    colunaSegundaria: string,
    valor: string,
    descricaoDataIndex: string,
    width: number
};

const tamanhoItens = {
    "widthIndex": 100,
    "widthCodigo": 150,
    "widthNomePacote": 350,
    "widthOrcado": 400,
    "widthContratado": 400,
    "widthExecutado": 400,
    "widthRequisitado": 400,
    "widthCompromissado": 400,
    "widthAContratar": 400,
    "widthForcast": 400,
    "widthSaldo": 400,
    "widthADistribuir": 400,
    "widthAVerificacaoPluriAnual": 400,
    "widthComprimissado": 400,
    "widthVerificacaoAnual": 400,
    "widthExecutadoNosAnosAnteriores": 400,
}

const larguraTotal = () => {
    return (
        tamanhoItens.widthIndex +
        tamanhoItens.widthCodigo +
        tamanhoItens.widthNomePacote +
        tamanhoItens.widthOrcado +
        tamanhoItens.widthExecutado +
        tamanhoItens.widthRequisitado +
        tamanhoItens.widthCompromissado +
        tamanhoItens.widthForcast +
        tamanhoItens.widthSaldo +
        tamanhoItens.widthADistribuir +
        tamanhoItens.widthAVerificacaoPluriAnual +
        tamanhoItens.widthComprimissado +
        tamanhoItens.widthVerificacaoAnual +
        tamanhoItens.widthExecutadoNosAnosAnteriores
    );
}

const FormADistribuir = (props: PropFormAContratar) => {
    const { selectedItem, listTipoDistribuicaoForcast } = props;
    const [totalizador, setTotalizador] = useState<tipoColuna[]>();
    const [projetoOrdemInvestimentoADistribuirTotalizadorResult, setprojetoOrdemInvestimentoADistribuirTotalizadorResult] = useState<ProjetoOrdemInvestimentoADistribuirTotalizador>();
    const [tipoDistribuicaoForcast, setTipoDistribuicaoForcast] = useState<OptionProps[]>(listTipoDistribuicaoForcast);
    const [paginacao, setPaginacao] = useState(5);
    const [status, setStatus] = useState({ status: 'N/A', data: '', projetoId: selectedItem.id, mensagem: '' })
    const [url, setURL] = useState(window.location.href);

    let timer: any;

    const getStatusAtualizacao = () => {
        getStatusAtualizacaoADistribuirByProjeto(selectedItem.id).then((data) => {
            if (data && data.status) {
                if (data.status.status !== status.status) {
                    if (data.status.status === "Finalizado") {
                        hasgetAllADistribuirByProjetoId(selectedItem.id);
                        clearInterval(timer);
                        if (status.status === "Executando") {
                            notification.success("Informações da tabela atualizadas.");
                        }
                    }
                    if (data.status.status === "Erro") {
                        clearInterval(timer);
                        notification.error("Houve um erro durante a atualização dos dados.");
                    }
                    setStatus({ ...status, status: data.status.status, data: data.status.ultimaAtualizacao, projetoId: selectedItem.id, mensagem: data.status.mensagem });
                }
            }
        });
    }

    useEffect(() => {
        if (status.status !== "N/A" && status.status !== "Finalizado" && status.status !== "Erro") {
            // call function every second
            timer = !timer && setInterval(() => {
                getStatusAtualizacao();
            }, 5000);
        }
        return () => clearInterval(timer); // cleanup function
    }, [status])

    useEffect(() => {
        if (window.location.href.toLocaleLowerCase().includes("adistribuir")) {
            getStatusAtualizacao();
        }
    }, [window.location.href])


    useMemo(async () => {
        if (selectedItem) {
            const resultProjetoOrdemInvestimentoPlurianualTotalizador = await getAllADistribuirByProjetoId(selectedItem.id);
            if (resultProjetoOrdemInvestimentoPlurianualTotalizador) {
                resultProjetoOrdemInvestimentoPlurianualTotalizador.ordemInvestimento.map((ordemInvestimento) => {
                    ordemInvestimento.anoMes.map((mesAno) => {
                        ordemInvestimento[mesAno.dataIndex] = mesAno.totalColunaAnoMes;
                    });
                    ordemInvestimento.anoMesADistribuir.map((aDistribuir) => {
                        ordemInvestimento[aDistribuir.dataIndex] = aDistribuir.totalColunaAnoMes;
                    });
                });
                setprojetoOrdemInvestimentoADistribuirTotalizadorResult(resultProjetoOrdemInvestimentoPlurianualTotalizador);
            }
        }
    }, [selectedItem]);


    const carregarTabelaADistribuir = () => {
        if (selectedItem) {
            // getAllADistribuirByProjetoId(selectedItem.id).then((resultProjetoOrdemInvestimentoPlurianualTotalizador) => {
            //     if (resultProjetoOrdemInvestimentoPlurianualTotalizador) {
            //         resultProjetoOrdemInvestimentoPlurianualTotalizador.ordemInvestimento.map((ordemInvestimento) => {
            //             ordemInvestimento.anoMes.map((mesAno) => {
            //                 ordemInvestimento[mesAno.dataIndex] = mesAno.totalColunaAnoMes;
            //             });
            //             ordemInvestimento.anoMesADistribuir.map((aDistribuir) => {
            //                 ordemInvestimento[aDistribuir.dataIndex] = aDistribuir.totalColunaAnoMes;
            //             });
            //         });
            //         setprojetoOrdemInvestimentoADistribuirTotalizadorResult(resultProjetoOrdemInvestimentoPlurianualTotalizador);
            //     }
            // });
            hasgetAllADistribuirByProjetoId(selectedItem.id);
        }
    }

    const hasgetAllADistribuirByProjetoId = (projetoId: string) => {
        getAllADistribuirByProjetoId(projetoId).then((resultProjetoOrdemInvestimentoPlurianualTotalizador) => {
            if (resultProjetoOrdemInvestimentoPlurianualTotalizador) {
                resultProjetoOrdemInvestimentoPlurianualTotalizador.ordemInvestimento.map((ordemInvestimento) => {
                    ordemInvestimento.anoMes.map((mesAno) => {
                        ordemInvestimento[mesAno.dataIndex] = mesAno.totalColunaAnoMes;
                    });
                    ordemInvestimento.anoMesADistribuir.map((aDistribuir) => {
                        ordemInvestimento[aDistribuir.dataIndex] = aDistribuir.totalColunaAnoMes;
                    });
                });
                setprojetoOrdemInvestimentoADistribuirTotalizadorResult(resultProjetoOrdemInvestimentoPlurianualTotalizador);
            }
        });
    }

    const convertStringToMoment = (dateString: string) => {
        if (dateString === null || dateString === "")
            return null;
        return moment(dateString, "MM/YYYY");
    }

    const changeTipoDistribuicao = (consolidadoPlurianualId: string, tipoDistribuicaoForcastId: string) => {
        if (selectedItem) {
            updateTipoDistribuicaoConsolidadoPlurianual(consolidadoPlurianualId, tipoDistribuicaoForcastId, selectedItem.id).then((data) => {
                carregarTabelaADistribuir();
            });
        }
    }



    const changeDataInicialEFinal = (consolidadoPlurianualId: string, ordemInvestimentoId: string, dataInicial: string, dataFinal: string, valorADistribuir: number) => {
        if (selectedItem && projetoOrdemInvestimentoADistribuirTotalizadorResult) {

            if (dataInicial != undefined && dataInicial != "" && dataInicial != null) {
                updatePeriodoInicialConsolidadoPluriAnual(consolidadoPlurianualId, ordemInvestimentoId, dataInicial, selectedItem.id, valorADistribuir).then((data) => {
                    if (data) {
                        const result = data as ProjetoOrdemInvestimentoADistribuirTotalizador;
                        if (result.valid) {
                            carregarTabelaADistribuir();
                        }
                    }
                });
            }

            if (dataFinal != undefined && dataFinal != "" && dataFinal != null) {
                updatePeriodoFinalConsolidadoPluriAnual(consolidadoPlurianualId, ordemInvestimentoId, dataFinal, selectedItem.id, valorADistribuir).then((data) => {
                    if (data) {
                        const result = data as ProjetoOrdemInvestimentoADistribuirTotalizador;
                        if (result.valid) {
                            carregarTabelaADistribuir();
                        }
                    }
                });
            }
        }
    }

    useEffect(() => {
        if (projetoOrdemInvestimentoADistribuirTotalizadorResult) {
            let array = [
                {
                    colunaPrincipal: 'A',
                    colunaSegundaria: 'Orçado',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaA}`,
                    descricaoDataIndex: 'orcadoFormatado',
                    width: tamanhoItens.widthOrcado,
                },
                {
                    colunaPrincipal: 'B',
                    colunaSegundaria: 'Contratado',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaB}`,
                    descricaoDataIndex: 'contratadoFormatado',
                    width: tamanhoItens.widthContratado,

                },
                {
                    colunaPrincipal: 'C',
                    colunaSegundaria: 'Executado',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaC}`,
                    descricaoDataIndex: 'executadoFormatado',
                    width: tamanhoItens.widthExecutado,
                },
                {
                    colunaPrincipal: 'D',
                    colunaSegundaria: 'Requisitado',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaD}`,
                    descricaoDataIndex: 'requisitadoFormatado',
                    width: tamanhoItens.widthRequisitado
                },
                {
                    colunaPrincipal: 'E = B - C + D',
                    colunaSegundaria: 'Compromissado',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaE}`,
                    descricaoDataIndex: 'compromissadoFormatado',
                    width: tamanhoItens.widthCompromissado,
                },
                {
                    colunaPrincipal: 'F',
                    colunaSegundaria: 'A Contratar',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaF}`,
                    descricaoDataIndex: 'aContratarFormatado',
                    width: tamanhoItens.widthAContratar,
                },
                {
                    colunaPrincipal: 'G = B + D + F',
                    colunaSegundaria: 'Forecast',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaG}`,
                    descricaoDataIndex: 'forcastFormatado',
                    width: tamanhoItens.widthForcast,
                },
                {
                    colunaPrincipal: 'H = A - G',
                    colunaSegundaria: 'Saldo',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaH}`,
                    descricaoDataIndex: 'saldoFormatado',
                    width: tamanhoItens.widthSaldo,
                },
                {
                    colunaPrincipal: 'I = G - C',
                    colunaSegundaria: 'A Distribuir',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaI}`,
                    descricaoDataIndex: 'aDistribuirFormatado',
                    width: tamanhoItens.widthADistribuir,
                },
                {
                    colunaPrincipal: 'Verificação Plurianual',
                    colunaSegundaria: '',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaVerificacaoPlaurianual}`,
                    descricaoDataIndex: 'verificacaoPlurianualFormatado',
                    width: tamanhoItens.widthAVerificacaoPluriAnual,
                },
                {
                    colunaPrincipal: 'J = B - C + D',
                    colunaSegundaria: `Compromissado ${projetoOrdemInvestimentoADistribuirTotalizadorResult.anoReferencia} `,
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalColunaJ}`,
                    descricaoDataIndex: 'compromissadoAnoFormatado',
                    width: tamanhoItens.widthComprimissado,
                },
                {
                    colunaPrincipal: 'Verificação Anual',
                    colunaSegundaria: '',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalVerificacaoAnual}`,
                    descricaoDataIndex: 'verificacaoAnualFormatado',
                    width: tamanhoItens.widthVerificacaoAnual,
                },
                {
                    colunaPrincipal: 'Executado nos anos anteriores',
                    colunaSegundaria: '',
                    valor: `${projetoOrdemInvestimentoADistribuirTotalizadorResult.totalExecutadoNosAnosAnteriores}`,
                    descricaoDataIndex: 'executadoAnosAnteriosFormatado',
                    width: tamanhoItens.widthExecutadoNosAnosAnteriores,
                },

            ] as tipoColuna[];
            setTotalizador(array);
        } else {
            setTotalizador([]);
        }
    }, [selectedItem, projetoOrdemInvestimentoADistribuirTotalizadorResult]);


    const gerarLinkRequisitado = (projetoId: any, record: any) => {
        if (record.requisitado != 0.00 && record.children === undefined) {
            return <LinkRequisitadoProjeto
                projetoId={projetoId}
                codigoPacote={record.ordemInvestimentoCodPacote}
                descricaoLink={record.requisitadoFormatado}
            />
        }
        return <> {record.requisitadoFormatado} </>
    }

    const collunsAContratar = useMemo(() => {
        if (totalizador && projetoOrdemInvestimentoADistribuirTotalizadorResult) {
            let colluns: ColumnProps<any>[] = [
                {
                    title: 'N',
                    dataIndex: 'numeroLinha',
                    width: tamanhoItens.widthIndex,
                    fixed: 'left',
                },
                {
                    title: 'CÓDIGO',
                    dataIndex: 'codigoPacote',
                    width: tamanhoItens.widthCodigo,
                    fixed: 'left',
                    sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar CÓDIGO"
                                    name="codigoPacote"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.codigoPacote !== undefined &&
                        record.codigoPacote
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                },
                {
                    title: 'NOME PACOTE',
                    dataIndex: 'nomePacote',
                    fixed: 'left',
                    width: tamanhoItens.widthNomePacote,
                    sorter: (a, b) => compareText(a.nomePacote, b.nomePacote),
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <Form>
                            <Row>
                                <FormInput
                                    placeholder="Pesquisar NOME PACOTE"
                                    name="nomePacote"
                                    style={{ marginTop: '15px' }}
                                    onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
                                    onPressEnter={() => {
                                        if (typeof confirm === 'function') confirm();
                                    }}
                                />
                            </Row>
                            <Row>
                                <Col span={6}>
                                    <Button
                                        type="primary"
                                        style={{ marginLeft: '5px' }}
                                        onClick={() => {
                                            if (typeof confirm === 'function') confirm();
                                        }}
                                        icon="commons-search"
                                        size="small">
                                        Pesquisar
                                    </Button>
                                </Col>
                                <Col span={6}>
                                    <FormResetButton
                                        size="small"
                                        style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                                        beforeReset={() => {
                                            if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                                        }}>
                                        Limpar
                                    </FormResetButton>
                                </Col>
                            </Row>
                        </Form>
                    ),
                    filterIcon: filtered => {
                        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';
                        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
                    },
                    onFilter: (value, record) =>
                        record.nomePacote !== undefined &&
                        record.nomePacote
                            .toString()
                            .toLowerCase()
                            .includes(value.toLowerCase()),
                }
            ];

            totalizador.map((tipoColuna) => {
                if (tipoColuna.colunaSegundaria === "Requisitado") {
                    colluns.push({
                        title: `${tipoColuna.valor}`,
                        width: `${tipoColuna.width}`,
                        children: [{
                            title: `${tipoColuna.colunaPrincipal}`,
                            width: `${tipoColuna.width}`,
                            children: [{
                                title: `${tipoColuna.colunaSegundaria}`,
                                width: `${tipoColuna.width}`,
                                dataIndex: `${tipoColuna.descricaoDataIndex}`,
                                align: 'center',
                                render: ((text, record) => {
                                    if (selectedItem)
                                        return gerarLinkRequisitado(selectedItem.id, record);
                                })
                            }]
                        }]
                    });
                } else {
                    if (tipoColuna.colunaSegundaria != '') {
                        colluns.push({
                            title: `${tipoColuna.valor}`,
                            width: `${tipoColuna.width}`,
                            children: [{
                                title: `${tipoColuna.colunaPrincipal}`,
                                width: `${tipoColuna.width}`,
                                children: [{
                                    title: `${tipoColuna.colunaSegundaria}`,
                                    width: `${tipoColuna.width}`,
                                    dataIndex: `${tipoColuna.descricaoDataIndex}`,
                                    align: 'center',
                                    render: ((text, record) => {
                                        return <> {record[tipoColuna.descricaoDataIndex]}</>
                                    })
                                }]
                            }]
                        });
                    } else {
                        colluns.push({
                            title: `${tipoColuna.valor}`,
                            width: `${tipoColuna.width}`,
                            children: [{
                                title: `${tipoColuna.colunaPrincipal}`,
                                dataIndex: `${tipoColuna.descricaoDataIndex}`,
                                width: `${tipoColuna.width}`,
                                align: 'center',
                                render: ((text, record) => {
                                    return <> {record[tipoColuna.descricaoDataIndex]}</>
                                })
                            }]
                        });
                    }
                }
            });

            if (projetoOrdemInvestimentoADistribuirTotalizadorResult
                && projetoOrdemInvestimentoADistribuirTotalizadorResult.anoMes.length > 0) {

                projetoOrdemInvestimentoADistribuirTotalizadorResult.anoMes.filter((anoMes) => {
                    colluns.push(
                        {
                            title: `${anoMes.totalColunaAnoMes}`,
                            children: [
                                {
                                    title: `Executado`,
                                    align: 'center',
                                    children: [
                                        {
                                            title: `${anoMes.anoMes}`,
                                            dataIndex: `${anoMes.dataIndex}`,
                                            align: 'center',
                                        }
                                    ]
                                }
                            ]
                        }
                    );
                });
            }

            colluns.push(
                {
                    title: 'DISTRIBUIÇÃO',
                    children: [
                        {
                            title: `Tipo de distribuição`,
                            dataIndex: `tipoDistribuicao`,
                            render: ((text, record) => {
                                if (record.mostrarADistribuir === "true") {
                                    return <>
                                        <FormSelect
                                            name={`tipoDistribuicao${record.consolidadoPlurianualId}`}
                                            placeholder="Selecione uma opção"
                                            value={record.tipoDistribuicaoForcastId}
                                            style={{ width: 150 }}
                                            options={tipoDistribuicaoForcast}
                                            onChange={(handleChange) => {
                                                changeTipoDistribuicao(record.consolidadoPlurianualId, handleChange as string);

                                            }}
                                        />
                                    </>
                                } else {
                                    return <>


                                    </>
                                }
                            })
                        },
                        {
                            title: `Período INICIO`,
                            dataIndex: `pereiodoInicio`,
                            render: ((text, record) => {
                                if (record.mostrarADistribuir === "true") {
                                    return <>
                                        <FormMonthPicker
                                            name={`pereiodoInicio${record.consolidadoPlurianualId}`}
                                            format="MM/YYYY"
                                            disabled={record.tipoDistribuicaoForcastCodigo === "1"}
                                            style={{ width: 150 }}
                                            value={convertStringToMoment(record.periodoInicioFormatado)}
                                            onChange={(date) => {
                                                if (date) {
                                                    const valorADistribuir = record.aDistribuir as number;
                                                    changeDataInicialEFinal(record.consolidadoPlurianualId, record.ordemInvestimentoId, date.format("MM/YYYY").toString(), "", valorADistribuir);
                                                }
                                            }}
                                        />
                                    </>
                                } else {
                                    return <></>
                                }
                            })
                        },
                        {
                            title: `Período FIM`,
                            dataIndex: `periodoFim`,
                            render: ((text, record) => {
                                if (record.mostrarADistribuir === "true") {
                                    return <>
                                        <FormMonthPicker
                                            name={`periodoFim${record.consolidadoPlurianualId}`}
                                            format="MM/YYYY"
                                            disabled={record.tipoDistribuicaoForcastCodigo === "1"}
                                            style={{ width: 150 }}
                                            value={convertStringToMoment(record.periodoFimFormatado)}
                                            onChange={(date) => {
                                                if (date) {
                                                    if (date) {
                                                        const valorADistribuirFormatado = record.aDistribuirFormatado as string;
                                                        const valorADistribuir = handleParser(valorADistribuirFormatado);
                                                        const valorNumer = parseFloat(valorADistribuir)
                                                        changeDataInicialEFinal(record.consolidadoPlurianualId, record.ordemInvestimentoId, "", date.format("MM/YYYY").toString(), valorNumer);
                                                    }
                                                }
                                            }}
                                        />
                                    </>
                                } else {
                                    return <></>
                                }
                            })
                        }
                    ]
                }
            );

            if (projetoOrdemInvestimentoADistribuirTotalizadorResult.anoMesADistribuir.length > 0) {
                projetoOrdemInvestimentoADistribuirTotalizadorResult.anoMesADistribuir.filter((anoMesADistribuir) => {
                    colluns.push(
                        {
                            title: `${anoMesADistribuir.totalColunaAnoMes}`,
                            dataIndex: `${anoMesADistribuir.dataIndex}`,
                            children: [
                                {
                                    title: "À Distribuir (Forecast)",
                                    dataIndex: `${anoMesADistribuir.dataIndex}`,
                                    children: [
                                        {
                                            title: `${anoMesADistribuir.anoMes}`,
                                            dataIndex: `${anoMesADistribuir.dataIndex}`,
                                            align: 'center',
                                            render: ((text, record) => {
                                                if (record.mostrarADistribuir === "true") {
                                                    if (record.tipoDistribuicaoForcastCodigo === "1") {
                                                        return <>
                                                            {

                                                                <CurrencyInput
                                                                    id={`valorPeriodo${anoMesADistribuir.dataIndex}_${record.consolidadoPlurianualId}`}
                                                                    name={`valorPeriodo${anoMesADistribuir.dataIndex}_${record.consolidadoPlurianualId}`}
                                                                    value={record[anoMesADistribuir.dataIndex]}
                                                                    defaultValue={record[anoMesADistribuir.dataIndex]}
                                                                    style={{ width: 100 }}
                                                                    onBlur={() => { }}
                                                                    onChange={e => {
                                                                        record[anoMesADistribuir.dataIndex] = e;
                                                                    }}
                                                                    onKeyDown={e => {
                                                                        if (e.key === 'Enter') {
                                                                            if (selectedItem) {
                                                                                const projetoId = selectedItem.id;
                                                                                const consolidadoPlurianualId = record.consolidadoPlurianualId;
                                                                                const ordemInvestimentoAlteradoId = record.ordemInvestimentoId;
                                                                                const itemDistribuicaoId = record[anoMesADistribuir.dataIndex + 'itemDistribuicaoId'];
                                                                                const codigo = record[anoMesADistribuir.dataIndex + 'codigoItemDitribuicao'];
                                                                                const valor = record[anoMesADistribuir.dataIndex] as number
                                                                                if (projetoId != undefined && ordemInvestimentoAlteradoId != undefined && consolidadoPlurianualId != undefined && itemDistribuicaoId != undefined && codigo != undefined && valor != undefined) {
                                                                                    atualizarValoresADistribuir(consolidadoPlurianualId, ordemInvestimentoAlteradoId, itemDistribuicaoId, codigo, valor, anoMesADistribuir.dataIndex);
                                                                                    updateValorConsolidadoPluriAnualItemDistribuir(itemDistribuicaoId, projetoId, valor, codigo);
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                />
                                                            }
                                                        </>
                                                    }
                                                    return <>{currencyFormat(record[anoMesADistribuir.dataIndex] + 'Formatado')}</>
                                                } else {
                                                    if (record.numeroLinha != null && record.numeroLinha != undefined) {
                                                        return <>{record[anoMesADistribuir.dataIndex]}</>
                                                    }
                                                }
                                            })
                                        }
                                    ]
                                }
                            ]

                        }
                    );
                });
            }


            return colluns;
        }
        return [];
    }, [totalizador]);


    const atualizarValoresADistribuir = (consolidadoPlurianualId: string, ordemInvestimentoAlteradoId: string, itemDistribuicaoId: string, codigo: any, valor: number, dataIndex: any) => {
        if (projetoOrdemInvestimentoADistribuirTotalizadorResult) {
            const resultado = (projetoOrdemInvestimentoADistribuirTotalizadorResult.ordemInvestimento.filter((ordemInvestimento) => {
                if (ordemInvestimento.id === ordemInvestimentoAlteradoId) {
                    ordemInvestimento.children.filter((distribuicao) => {
                        if (distribuicao.consolidadoPlurianualId === consolidadoPlurianualId) {
                            distribuicao[dataIndex] = valor;
                        }
                    });
                }
                return ordemInvestimento;
            }));
            atualizarItensContexto(resultado);
        }
    }

    const atualizarItensContexto = (result: ProjetoOrdemInvestimentoPlurianual[]) => {
        if (projetoOrdemInvestimentoADistribuirTotalizadorResult && result) {
            let newProjetoOrdemInvestimentoADistribuirTotalizadorResult = { ...projetoOrdemInvestimentoADistribuirTotalizadorResult }
            newProjetoOrdemInvestimentoADistribuirTotalizadorResult.ordemInvestimento = result;
            setprojetoOrdemInvestimentoADistribuirTotalizadorResult(newProjetoOrdemInvestimentoADistribuirTotalizadorResult);
        }
    }

    const adcionarMesAno = (projetoId: string) => {
        const anoInt = Number(0);
        const mesInt = Number(0);
        CreatAdcionarMesAno(projetoId, anoInt, mesInt).then((data) => {
            if (data && data.valid) {
                carregarTabelaADistribuir();
            }
        });
    }

    const hasExportar = (projetoId: string, nomeProjeto: string) => {
        exportarADistribuir(projetoId, nomeProjeto);
    }



    const atualizarPagaincacao = (paginacaco: number) => {
        setPaginacao(paginacaco);
    }

    const enderecoPostFileImportADistribuir = 'projetos/importarPlanilhaADistrubuir';

    const getAllAContratarProjeto = (projetoId: string, atualizarTabela: boolean) => {

        if (atualizarTabela)
            notification.info("O sistema está atualizando as informações da tabela. O processo pode demorar alguns minutos.");

        getAllContratoOrdemInvestimentoPlurianualByProjetoId(projetoId, atualizarTabela)
            .then((resultProjetoOrdemInvestimentoPlurianualTotalizador) => {
                getStatusAtualizacao();
                if (resultProjetoOrdemInvestimentoPlurianualTotalizador) {
                    hasgetAllADistribuirByProjetoId(projetoId);
                }
            });
    }

    return (<>
        {selectedItem
            && totalizador
            && projetoOrdemInvestimentoADistribuirTotalizadorResult
            && projetoOrdemInvestimentoADistribuirTotalizadorResult.ordemInvestimento.length > 0 ? (

            <MasterDetailForm>
                <Widget
                    title={'A CONTRATAR PLURIANUAL'}
                    actions={[
                        <Button
                            type="link"
                            name="btnAtualizarTabela"
                            icon="ui-available_updates"
                            onClick={() => {
                                getAllAContratarProjeto(selectedItem.id, true);
                            }}>
                            <FormatText id="ui.commons.save" uppercase transform={() => "ATUALIZAR ADISTRIBUIR"} />
                        </Button>,

                        <Button
                            type="link"
                            name="btnExportar"
                            icon="data-export"
                            onClick={() => {
                                hasExportar(selectedItem.id, selectedItem.codigo);
                            }}>
                            <FormatText id="data-export" uppercase transform={() => "Exportar"} />
                        </Button>,
                        <UploadFileDefault
                            descricaoBotao="Importar ADistribuir"
                            id={selectedItem && selectedItem.id}
                            idDoComponente={'btnImportFilePlanilha'}
                            enderecoApi={enderecoPostFileImportADistribuir}
                            nomeIdFormulario={'ProjetoId'}
                            retorno={() => {
                                carregarTabelaADistribuir();
                            }}
                        />,
                        <FormSubmitButton
                            type="primary"
                            onClick={() => {
                                adcionarMesAno(selectedItem.id);
                            }}>
                            <FormatText id="ui.commons.save" uppercase transform={() => "ADICIONAR MES/ANO"} />
                        </FormSubmitButton>,
                    ]}>
                    <div>
                        <Row style={{ display: "flex" }} >
                            <div className="table-operations">
                                <PaginacaoTabela atualizarTabela={atualizarPagaincacao} />
                            </div>
                            <div className="ant-row ant-form-item" style={{ float: 'inline-end' }} >
                                <div className="ant-col ant-form-item-label">
                                    <label className="ant-form-item-no-colon" title="">
                                        <span className="ant-app-text">Status Atualização</span>
                                    </label>
                                </div>
                                <div className="ant-col ant-form-item-control-wrapper">
                                    <div className="ant-form-item-control">
                                        <span className="ant-form-item-children">
                                            <Tooltip title={status.mensagem} >
                                                <Input style={{ width: '150px' }} value={`${status.status}`} disabled />
                                            </Tooltip>
                                        </span>
                                    </div>
                                </div>
                            </div>

                        </Row>
                        <Table
                            rowKey={"id"}
                            scroll={{ x: larguraTotal() }}
                            id={'tableADistribuir'}
                            columns={collunsAContratar}
                            dataSource={projetoOrdemInvestimentoADistribuirTotalizadorResult.ordemInvestimento}
                            pagination={{
                                pageSize: paginacao,
                                onChange: (() => {
                                    document.getElementById("tableADistribuir").scrollIntoView();
                                })
                            } as PaginationConfig}

                        />

                    </div>
                </Widget>
            </MasterDetailForm>

        ) : (<> </>)}

    </>);
}

export default FormADistribuir;

